import library from '../../library.json';

export function getAllWorks() {
  return [].concat(library.works);
}

export function getAllSeries() {
  return [].concat(library.series);
}

export function getSeriesById(id) {
  const series = library.series.find(item => item.id === id);
  return series;
}

export function getWorkById(id) {
  const work = library.works.find(item => item.id === id);

  return work;
}

export function getSeriesByWorkId(id) {
  const series = library.series.find(item => item.works.indexOf(id) > -1);
  return series;
}

export function getWorksByType(type) {
  const typeId = (type === 'photography') ? null : type;
  const works = library.works.filter(item => item.type == typeId);

  return works;
}



// WEBPACK FOOTER //
// ./application/js/lib/library.js